import { render } from "./AccordionItem.vue?vue&type=template&id=6ef2ee10&scoped=true"
import script from "./AccordionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionItem.vue?vue&type=script&setup=true&lang=js"

import "./AccordionItem.vue?vue&type=style&index=0&id=6ef2ee10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef2ee10"],['__file',"src/components/Utility/AccordionItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ef2ee10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ef2ee10', __exports__)) {
    api.reload('6ef2ee10', __exports__)
  }
  
  module.hot.accept("./AccordionItem.vue?vue&type=template&id=6ef2ee10&scoped=true", () => {
    api.rerender('6ef2ee10', render)
  })

}


export default __exports__